export const sliderItems = [
    {
        id: 1,
        img: "https://img.freepik.com/free-photo/portrait-beautiful-caucasian-smiling-brunette-woman-model-with-double-pigtails-bright-pink-summer-stylish-clothes-isolated-white-background_158538-2978.jpg?w=740&t=st=1673765126~exp=1673765726~hmac=92801ba820b3b32f022547543b4009a90363f07ca2592aa38bc2c46f9293e3c5",
        title: "SUMMER SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "f5fafd",
    },
    {
        id: 2,
        img: "https://img.freepik.com/free-photo/portrait-beautiful-happy-cute-sexy-brunette-woman-with-red-lips-wide-classic-pants-white-background_158538-9357.jpg?t=st=1673765265~exp=1673765865~hmac=b8f94d9de3d0f19ddd01f9ffcd850849c718a23dcf7ab6654158c1bc13ab4598",
        title: "AUTUMN COLLECTION",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fcf1ed",
    },
    {
        id: 3,
        img: "https://img.freepik.com/free-photo/portrait-stylish-beautiful-young-woman-with-sunglasses_158538-4190.jpg?w=740&t=st=1673765510~exp=1673766110~hmac=0feb2f37f1a1f038ab600c92fc66c94e7e219930e3df60668d4c6f396b9e290b",
        title: "LOUNGEWEAR LOVE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fbf0f4",
    },
];

export const categories = [
    {
        id: 1,
        img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        title: "SHIRT STYLE!",
        categories:"shirt",
    },
    {
        id: 2,
        img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        title: "LOUNGEWEAR LOVE",
        categories:"loungewear",
    },
    {
        id: 3,
        img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        title: "LIGHT JACKETS",
        categories:"jacket",
    },
];

export const popularProducts = [
    {
        id:1,
        img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
        id:2,
        img:"https://lp2.hm.com/hmgoepprod?set=format%5Bwebp%5D%2Cquality%5B79%5D%2Csource%5B%2F85%2F7c%2F857c2e4dca877538396859d4d70f36f5907c5c6a.jpg%5D%2Corigin%5Bdam%5D%2Ccategory%5B%5D%2Ctype%5BDESCRIPTIVESTILLLIFE%5D%2Cres%5Bm%5D%2Chmver%5B2%5D&call=url%5Bfile%3A%2Fproduct%2Fmain%5D",
    },
    {
        id:3,
        img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
        id:4,
        img:"https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcT2EY6P1IMmwx1MSL8btB2DuBQJTY2k4oDEwP74MbuIyAKZ4OHoqbF44OWrglP4vTkJaAXO7IH2rWj5Vz4zve5QgFoFZ9Uj",
    },
    {
        id:5,
        img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
        id:6,
        img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
    },
    {
        id:7,
        img:"https://lp2.hm.com/hmgoepprod?set=source[/fe/7b/fe7bac1ec1529183e7900fe97e35fe0bbf8f4c6e.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[y],hmver[2]&call=url[file:/product/main]",
    },
    {
        id:8,
        img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
]